module.exports = __webpack_public_path__ + "static/media/arrow.f849e8f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Component/Landing/arrow.svg
// module id = 107
// module chunks = 0